import styled from "styled-components"

const inputHeight = 39

export const SearchBarWrapper = styled.div<{
    leftOffset: boolean
    rightOffset: boolean
}>`
    position: relative;
    width: 100%;
    height: ${inputHeight}px;
    box-sizing: border-box;
    margin-left: ${(props) => (props.leftOffset ? "40px" : "0")};
    margin-right: ${(props) => (props.rightOffset ? "30px" : "0")};
`
export const SearchBarInputWrapper = styled.div`
    position: absolute;
    display: flex;
    box-sizing: border-box;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 5px;
    background: ${(props) => props.theme.searchInputBackground};
`
export const SearchBarSelectedFilterWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
`
export const SearchBarInput = styled.input`
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background: none;
    padding: 0 10px;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.searchInputColor};

    &:focus {
        color: ${(props) => props.theme.searchInputFocusColor};
    }

    &::placeholder {
       color: ${(props) => props.theme.searchInputPlaceholderColor};
    }
`
export const ClearSearch = styled.div`
    display: flex;
    align-items: center;
    margin: 0 4px;
    user-select: none;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: ${(props) => props.theme.fontSizes.lg}px;
        color: ${(props) => props.theme.searchInputClearSearch};
        transition: ${(props) => props.theme.defaultTransition};

        &:hover {
            color: ${(props) => props.theme.searchInputClearSearchHover};
            transition: ${(props) => props.theme.defaultTransition};
        }
    }
`
export const SelectedFilter = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 29px;
    padding: 0 10px;
    margin-right: 3px;
    border-radius: 2px;
    background: ${(props) => props.theme.searchFilterBackground};

    &:last-child {
        margin-right: 15px;

        &::after {
            position: absolute;
            content: "+";
            display: block;
            width: 24px;
            left: 100%;
            text-align: center;
            color: ${(props) => props.theme.searchInputPlaceholderColor};
        }
    }
`
export const SelectedFilterTitle = styled.div`
    width: max-content;
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: default;
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.md}px;
    color: ${(props) => props.theme.searchFilterColor};
`
export const CloseButton = styled.div`
    user-select: none;
    margin-left: 7px;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: ${(props) => props.theme.fontSizes.xs}px;
        color: ${(props) => props.theme.searchFilterCloseButtonColor};
        transition: 0.1s ease;

        &:hover {
            color: ${(props) => props.theme.searchFilterCloseButtonHoverColor};
            transition: 0.1s ease;
        }
    }
`
export const SearchBarPopupWrapper = styled.div<{
    show: boolean
    showForm: boolean
}>`
    display: ${(props) => (props.show ? "flex" : "none")};
    flex-direction: row;
    position: absolute;
    width: ${(props) => (props.showForm ? "100%" : "fit-content")};
    top: ${inputHeight + 3}px;
    z-index: 10;
    box-shadow: 0 4px 8px rgb(0, 0, 0, 0.5);
`
export const SearchBarPopupSidebar = styled.div<{
    show: boolean
}>`
    display: ${(props) => (props.show ? "flex" : "none")};
    flex-direction: column;
    box-sizing: border-box;
    width: 215px;
    padding: 3px 20px;
    border-right: 1px solid ${(props) => props.theme.searchPopupFilterBorderRightColor};
    background: ${(props) => props.theme.searchPopupFilterBackground};
`
export const SearchBarPopupForm = styled.div<{
    show: boolean
}>`
    display: ${(props) => (props.show ? "flex" : "none")};
    flex-direction: column;
    flex-grow: 1;
    box-sizing: border-box;
    padding: 15px;
    background: ${(props) => props.theme.searchPopupFormBackground};
`
export const PopupFilter = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 10px;
    border-bottom: 1px solid ${(props) => props.theme.searchPopupFilterBorderBottomColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        padding-left: 13px;
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const PopupFilterTitle = styled.div<{
    isActive: boolean
}>`
    text-transform: uppercase;
    cursor: pointer;
    font-weight: ${(props) => (props.isActive ? 600 : "normal")};
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    color: ${(props) => (props.isActive ? props.theme.searchPopupFilterColorActive : props.theme.searchFilterColor)};
`
